/* unplugin-vue-components disabled */import script from "./MyCouponList.vue?vue&type=script&setup=true&lang=js"
export * from "./MyCouponList.vue?vue&type=script&setup=true&lang=js"

import "./MyCouponList.vue?vue&type=style&index=0&id=90817b9e&lang=scss"

const __exports__ = script;

export default __exports__